import React from "react"

import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import ExpandLessIcon from "@material-ui/icons/ExpandLess"

import "./showMore.scss"

const ShowMoreWrapper = (props) => {
  const [showMore, setShowMore] = React.useState(true)

  const handleShowMore = () => {
    if (showMore) {
      setShowMore(false)
    } else {
      setShowMore(true)
    }
  }
  return (
    <div className="show-more-wrapper">
      <div dangerouslySetInnerHTML={{ __html: props.item_1 }}></div>
      {props.item_2 ? (
        <div
          className="show_more"
          role="presentation"
          onClick={() => handleShowMore()}
          style={showMore ? { display: "none", transition: "500ms" } : {}}
        >
          {!showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>
      ) : null}
      <div
        className="show-more-desc"
        dangerouslySetInnerHTML={{ __html: props.item_2 }}
        style={showMore ? { display: "none", transition: "500ms" } : {}}
      ></div>
      {props.item_2 ? (
        <div
          className="show_more"
          role="presentation"
          onClick={() => handleShowMore()}
          style={showMore ? {} : { display: "none", transition: "500ms" }}
        >
          {!showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>
      ) : null}
    </div>
  )
}

export default ShowMoreWrapper
